<template>
<div>
  <div class="authentication-wrapper authentication-1 px-4">
    <div class="authentication-inner py-5">
      <loader v-if="showLoader"></loader>
      <p class="text-center">Loading...</p>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import Loader from '../../misc/components/./Loader'
import { setItem, getItem } from '../../../storage'

export default {
  name: 'userSetup',
  props: [],
  components: {
    Loader
  },
  data: () => {
    return {
      token: '',
      courseId: '',
      showLoader: false
    }
  },
  mounted () {
    this.loadUserSetup()
  },
  methods: {
    ...mapActions([
      'loadToken',
      'loadUserObj'
    ]),
    getQueryParamByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&')
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      let results = regex.exec(decodeURIComponent(url))
      if (!results || !results[2]) return ''
      return results[2].replace(/\+/g, ' ')
    },
    async loadUserSetup () {
      this.showLoader = true
      this.token = this.getQueryParamByName('token')
      this.courseId = this.getQueryParamByName('courseId')
      let dashboardProgram = this.getQueryParamByName('programCode')
      setItem('dashboardProgram', dashboardProgram)
      await this.loadToken(this.token)
      await this.loadUserObj()
      this.showLoader = false
      this.$parent.isUserSetup = false
      if (this.courseId) {
        return this.$router.push({ name: 'courseDashboard', params: { uuid: this.courseId } })
      } else {
        return this.$router.push({ name: 'dashboard' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/UserSetup.vue